import { UseMutationResult, useMutation } from "@tanstack/react-query";

import { RiskDirectoryView } from "api/generated/model";
import {
    getRisks,
    postRisksRiskDirectoryIdCopy,
} from "api/generated/risks/risks";

export const COPY_RISK_DIRECTORY_MUTATION = "copy-risk-directory-mutation";

async function findAvailableTitle(title: string): Promise<string> {
    // It is arbitrary, I just suspect 42 would not be enough in some cases.
    const MAX_FIND_TITLE_ATTEMPTS = 1242;
    let num = 1;
    while (num <= MAX_FIND_TITLE_ATTEMPTS) {
        const copyTitle = `${title} - ${num}`;
        const response = await getRisks({
            all_directories: true,
            title: copyTitle,
        });
        if (response.data.content.length === 0) {
            return copyTitle;
        }
        num += 1;
    }
    throw new Error(`Unable to find any available title after ${num} attempts`);
}

export function useCopyRiskDirectoryMutation(
    riskDirectoryId: number,
    title: string,
    onSuccess: (riskDirectoryCopy: RiskDirectoryView) => void
): UseMutationResult<RiskDirectoryView> {
    return useMutation({
        mutationKey: [COPY_RISK_DIRECTORY_MUTATION, riskDirectoryId],
        mutationFn: async () => {
            const copyTitle = await findAvailableTitle(title);
            const response = await postRisksRiskDirectoryIdCopy(
                riskDirectoryId,
                { title: copyTitle }
            );
            return response.data;
        },
        onSuccess,
    });
}
